<!-- 课程产品 -->
<template>
  <div
    class="course"
    style="min-width: 1600px;"
  >
    <NavBar
      :navIndex="navIndexs"
      :imgHeight="482"
    ></NavBar>
    <!-- <div style="padding:30px;"></div> -->
    <div style="position:relative;width: 100%;">
      <img
        style="width: 100%;"
        src="../assets/course-bg.png"
        alt=""
        class="mod-section-ad"
      >
      <div class="animate__animated animate__mian slogan">
        <div class="slogan-title">研究与创新</div>
        <div class="slogan-subtitle">
          学习知识，整理知识，探索知识，传承知识
        </div>
      </div>
    </div>
    <!-- 选择 -->
    <div style="display: flex;align-items: center;justify-content: center;">
      <div
        v-for="(item,index) in tabData"
        :key="index"
        class="select-tab"
        :class="item.status?'select-tab-true':'select-tab-false'"
        @click="selectContent(item.name,index)"
      >{{item.name}}</div>
      <!-- <div class="select-tab">科目介绍</div>
        <div class="select-tab">产品创新</div> -->
    </div>

    <!-- 内容 -->
    <div style="background-color: #f7f7f7;padding-top: 50px;">
      <div
        id="课程设置"
        class="anchorPoint"
      ></div>

      <contentTitle text='课程设置' />
      <div class="content-big-box mw-1200 m_auto">
        <div class="content-box">

          <img
            class="content-img scaleImg_hover"
            src="../assets/home-page/1.png"
            alt=""
          >
          <div class="content-text-box">
            <div class="content-title">一对一课堂</div>
            <div class="content-text">专属教师一对一教学，每位学生配备专门的学习管理师进行课前课后跟踪服务。</div>
          </div>
        </div>

        <div class="content-box">
          <img
            class="content-img scaleImg_hover"
            src="../assets/home-page/2.png"
            alt=""
          >
          <div class="content-text-box">
            <div class="content-title">常规班课</div>
            <div class="content-text">6-20人的不同班型，春暑秋寒四期全科目覆盖，分为同步、提高、培优等层次。</div>
          </div>
        </div>

        <div class="content-box">
          <img
            class="content-img scaleImg_hover"
            src="../assets/home-page/3.png"
            alt=""
          >
          <div class="content-text-box">
            <div class="content-title">专题突破课程</div>
            <div class="content-text">各科目针对特定专项内容开设的短期突破课程，短时间内提升学生的薄弱板块。</div>
          </div>
        </div>

        <div class="content-box">
          <img
            class="content-img scaleImg_hover"
            src="../assets/home-page/4.png"
            alt=""
          >
          <div class="content-text-box">
            <div class="content-title">全日制课程</div>
            <div class="content-text">全天候一对一教学，专属学管师贴心服务， 包含早晚自习与周测等全方位学习环节。</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 科目介绍 -->
    <div class="subject-big-box">
      <div
        id="科目介绍"
        class="anchorPoint"
      ></div>

      <contentTitle
        text='科目介绍'
        style="margin-bottom: 30px;"
      />
      <div style="position: relative;width: 1200px;margin: auto;">
        <div style="position: relative;text-align: left;background-color: #fff;padding: 30px 35px;">
          <div
            id="wl"
            style="width: 100px;height: 100px;position: absolute;top: -50px;background-color:transparent;"
          ></div>
          <!-- <div style=""> -->
          <div class="subtitle">
            物理
            <div
              class=""
              style="position:absolute;width: 32px;height:2px;background-color: #0050A7;bottom: -25%;"
            ></div>
          </div>

          <div style="display: flex;margin-top: 20px;justify-content: center;">
            <img
              class="scaleImg_hover br-r6"
              style="width: 600px;"
              src="../assets/course-page/wuli.png"
              alt=""
            >
          </div>

          <div class="si_content">弘知最具优势的学科，教研工作立足于培养学生物理学科的核心素养。充分激发学生对生活中和宇宙中物理知识的兴趣，培养学生严密的思维逻辑思维能力，力图在教学实践中引导学生搭建自己的物理学体系，在考试中取得优势。</div>

          <!-- </div> -->

        </div>

        <div style="position: relative;margin: 20px auto;text-align: left;background-color: #fff;padding: 30px 35px;">
          <div
            id="sx"
            style="width: 100px;height: 100px;position: absolute;top: -50px;background-color:transparent;"
          ></div>
          <!-- <div style=""> -->
          <div class="subtitle">
            数学
            <div
              class=""
              style="position:absolute;width: 32px;height:2px;background-color: #0050A7;bottom: -25%;"
            ></div>
          </div>

          <div style="display: flex;margin-top: 20px;justify-content: center;">
            <img
              class="scaleImg_hover br-r6"
              style="width: 600px;"
              src="../assets/course-page/shuxue.png"
              alt=""
            >
          </div>

          <div class="si_content">注重深入浅出、触类旁通地讲解数学原理，引导学生明白数学底层逻辑和数学规律。采用积分排行制，培养学生在竞争中感受学数学的乐趣，让理论与练习相结合，使学生具备举一反三的能力，逐一突破中高考数学知识重难点。</div>

          <!-- </div> -->

        </div>

        <div style="position: relative;margin: 20px auto;text-align: left;background-color: #fff;padding: 30px 35px;">
          <div
            id="hx"
            style="width: 100px;height: 100px;position: absolute;top: -50px;background-color:transparent;"
          ></div>
          <!-- <div style=""> -->
          <div class="subtitle">
            化学
            <div
              class=""
              style="position:absolute;width: 32px;height:2px;background-color: #0050A7;bottom: -25%;"
            ></div>
          </div>

          <div style="display: flex;margin-top: 20px;justify-content: center;">
            <img
              class="scaleImg_hover br-r6"
              style="width: 600px;"
              src="../assets/course-page/huaxue.png"
              alt=""
            >
          </div>

          <div class="si_content">课堂内容贴近考试与生活，趣味十足，充实丰富，强调培养学生求真务实的学习态度，帮助学生学以致用。知识讲解全面，解题方法巧妙，对月考和中高考把握精准，培养学生的问题意识，应用“问题”来点燃学生智慧之火。</div>

          <!-- </div> -->

        </div>

        <div style="position: relative;margin: 20px auto;text-align: left;background-color: #fff;padding: 30px 35px;">
          <div
            id="yy"
            style="width: 100px;height: 100px;position: absolute;top: -50px;background-color:transparent;"
          ></div>
          <!-- <div style=""> -->
          <div class="subtitle">
            英语
            <div
              class=""
              style="position:absolute;width: 32px;height:2px;background-color: #0050A7;bottom: -25%;"
            ></div>
          </div>

          <div style="display: flex;margin-top: 20px;justify-content: center;">
            <img
              class="scaleImg_hover br-r6"
              style="width: 600px;"
              src="../assets/course-page/yingyu.png"
              alt=""
            >
          </div>

          <div class="si_content">根据学生水平，调整课堂中英文的比例，尽量采用全英文课堂教学，营造适合学生学习的最佳语言环境。通过启发诱导，潜移默化地培养学生的英文思维能力。将学习与生活相结合，拓展各国文化背景知识，打造良好的语言能力。</div>

          <!-- </div> -->

        </div>

        <div style="position: relative;margin: 20px auto;text-align: left;background-color: #fff;padding: 30px 35px;">
          <div
            id="yw"
            style="width: 100px;height: 100px;position: absolute;top: -50px;background-color:transparent;"
          ></div>
          <!-- <div style=""> -->
          <div class="subtitle">
            语文
            <div
              class=""
              style="position:absolute;width: 32px;height:2px;background-color: #0050A7;bottom: -25%;"
            ></div>
          </div>

          <div style="display: flex;margin-top: 20px;justify-content: center;">
            <img
              class="scaleImg_hover br-r6"
              style="width: 600px;"
              src="../assets/course-page/yuwen.png"
              alt=""
            >
          </div>

          <div class="si_content">根据语文学科特有的人文性和实践性打造综合性语文教育，将语文知识与文化生活相结合，重视提高学生的语文综合素养。在提高成绩的同时塑造学生健康人格，提升审美情趣，培养浓厚的家国情怀，让学子成为中华文化的传承人。</div>

          <!-- </div> -->

        </div>

        <div style="position: relative;margin: 20px auto;text-align: left;background-color: #fff;padding: 30px 35px;">
          <div
            id="dl"
            style="width: 100px;height: 100px;position: absolute;top: -50px;background-color:transparent;"
          ></div>
          <div style="">
            <div class="subtitle">
              地理
              <div
                class=""
                style="position:absolute;width: 32px;height:2px;background-color: #0050A7;bottom: -25%;"
              ></div>
            </div>

            <div class="si_content">趣味性教学，老师与学生在课堂上以地理教材为基本载体，增加学生的人文地理知识，激发学生对地理课程学习的兴趣。晦涩难懂的知识辅以图片与视频进行讲解，重难点以综合集训为突破方式，可轻松突破毕业考试。</div>

          </div>

          <div style="display: flex;margin-top: 20px;">
            <!-- <div style="width:40%;height:300px;background-color: #ccc;margin: 10px;"></div>
                    <div style="width:40%;height:300px;background-color: #ccc;margin: 10px;"></div> -->
          </div>
        </div>

        <div style="position: relative;margin: 20px auto;text-align: left;background-color: #fff;padding: 30px 35px;">
          <div
            id="zz"
            style="width: 100px;height: 100px;position: absolute;top: -50px;background-color:transparent;"
          ></div>
          <div style="">
            <div class="subtitle">
              政治
              <div
                class=""
                style="position:absolute;width: 32px;height:2px;background-color: #0050A7;bottom: -25%;"
              ></div>
            </div>

            <div class="si_content">从大部头政治教材中筛选考试重难点，由老师带领学生一起制作每一单元的思维导图和复习提纲，重难点知识使用多个案例引导学生理解记忆。采用自主、合作、探究式的学习方法，让学生平时记得牢，考试答得准。</div>

          </div>

          <div style="display: flex;margin-top: 20px;">
            <!-- <div style="width:40%;height:300px;background-color: #ccc;margin: 10px;"></div>
                    <div style="width:40%;height:300px;background-color: #ccc;margin: 10px;"></div> -->
          </div>
        </div>

        <div style="position: relative;margin: 20px auto;text-align: left;background-color: #fff;padding: 30px 35px;">
          <div
            id="sw"
            style="width: 100px;height: 100px;position: absolute;top: -50px;background-color:transparent;"
          ></div>
          <div style="">
            <div class="subtitle">
              生物
              <div
                class=""
                style="position:absolute;width: 32px;height:2px;background-color: #0050A7;bottom: -25%;"
              ></div>
            </div>

            <div class="si_content">以“先理解，后记忆”为教学准绳，坚持以客观、科学的眼光认识生物知识，老师手把手带领学生一起摸清生物群体、结构之间的联系。弘知生物学练结合，以长沙各历年考试真题为练习题源，提分高效快捷。</div>

          </div>

          <div style="display: flex;margin-top: 20px;">
            <!-- <div style="width:40%;height:300px;background-color: #ccc;margin: 10px;"></div>
                    <div style="width:40%;height:300px;background-color: #ccc;margin: 10px;"></div> -->
          </div>
        </div>

        <div
          ref="scrollOne"
          style="position: relative;margin: 20px auto;text-align: left;background-color: #fff;padding: 30px 35px;"
        >
          <div
            id="ls"
            style="width: 100px;height: 100px;position: absolute;top: -50px;background-color:transparent;"
          ></div>
          <div style="">
            <div class="subtitle">
              历史
              <div
                class=""
                style="position:absolute;width: 32px;height:2px;background-color: #0050A7;bottom: -25%;"
              ></div>
            </div>

            <div class="si_content">重视历史学科的人文性特点，在教学中引导学生养成追本溯源、求真务实的学习态度，帮助学生在关键期形成正确的历史观。整理初高中历史学科高频考点，带领学生从细节处积累知识，不漏过任何一个得分点。</div>

          </div>

          <div style="display: flex;margin-top: 20px;">
            <!-- <div style="width:40%;height:300px;background-color: #ccc;margin: 10px;"></div>
                    <div style="width:40%;height:300px;background-color: #ccc;margin: 10px;"></div> -->
          </div>
        </div>
      </div>

      <!-- <div class="subject-cell-box" >
            
            <div class="position-relative" style="width:600px;height:320px;margin-right:20px;">
                <img class="top-cell-img" src="../assets/course-page/物理.png" alt="">
                <div class="subject-title" >物理</div>

                <div class="course-cell-hover" >
                    <img style="width:100%;height:100%;" src="../assets/course-page/物理.png" alt="">
                    <div class="course-hover-content" >
                      <div class="course-title-box" style="font-size:26px;color: #fff;">
                        物理
                      </div>
      
                      <div class="course-hover-text">分春暑秋寒四期，针对初高中学生，提供语文、数学、英语、物理、化学小班授课，由教学经验丰富的名师授课，分为同步、提高、培优等班型。分层次、限人数，确保每一位学生都有收获。</div>
      
                      <img style="width:38px;" src="../assets/click-img.png" alt="">
                    </div>
                </div>
            </div>

            
            <div  class="position-relative">
                <img class="top-right-img" src="../assets/course-page/化学.png" alt="">
                <div class="subject-title">化学</div>

                <div class="course-cell-hover" >
                    <img style="width:100%;height:100%;" src="../assets/course-page/化学.png" alt="">
                    <div class="course-hover-content" >
                      <div class="course-title-box" style="font-size:26px;color: #fff;">
                        化学
                      </div>
      
                      <div class="course-hover-text">分春暑秋寒四期，针对初高中学生，提供语文、数学、英语、物理、化学小班授课，由教学经验丰富的名师授课，分为同步、提高、培优等班型。分层次、限人数，确保每一位学生都有收获。</div>
      
                      <img style="width:38px;" src="../assets/click-img.png" alt="">
                    </div>
                </div>
            </div>
        </div>

        <div class="subject-cell-box" style="margin-top: 20px;">
            
            <div class="position-relative">
                <img class="bottom-margin-img" src="../assets/course-page/数学.png" alt="">
                <div class="subject-title">数学</div>

                <div class="course-cell-hover" >
                    <img style="width:100%;height:100%;" src="../assets/course-page/数学.png" alt="">
                    <div class="course-hover-content" >
                      <div class="course-title-box" style="font-size:26px;color: #fff;">
                        数学
                      </div>
      
                      <div class="course-hover-text">分春暑秋寒四期，针对初高中学生，提供语文、数学、英语、物理、化学小班授课，由教学经验丰富的名师授课，分为同步、提高、培优等班型。分层次、限人数，确保每一位学生都有收获。</div>
      
                      <img style="width:38px;" src="../assets/click-img.png" alt="">
                    </div>
                </div>
            </div>
            
            <div class="position-relative">
                <img class="bottom-margin-img" src="../assets/course-page/语文.png" alt="">
                <div class="subject-title">语文</div>

                <div class="course-cell-hover" >
                    <img style="width:100%;height:100%;" src="../assets/course-page/语文.png" alt="">
                    <div class="course-hover-content" >
                      <div class="course-title-box" style="font-size:26px;color: #fff;">
                        语文
                      </div>
      
                      <div class="course-hover-text">分春暑秋寒四期，针对初高中学生，提供语文、数学、英语、物理、化学小班授课，由教学经验丰富的名师授课，分为同步、提高、培优等班型。分层次、限人数，确保每一位学生都有收获。</div>
      
                      <img style="width:38px;" src="../assets/click-img.png" alt="">
                    </div>
                </div>
            </div>
           
            <div class="position-relative">
                <img class="bottom-img" src="../assets/course-page/英语.png" alt="">
                <div class="subject-title">英语</div>

                <div class="course-cell-hover" >
                    <img style="width:100%;height:100%;" src="../assets/course-page/英语.png" alt="">
                    <div class="course-hover-content" >
                      <div class="course-title-box" style="font-size:26px;color: #fff;">
                        英语
                      </div>
      
                      <div class="course-hover-text">分春暑秋寒四期，针对初高中学生，提供语文、数学、英语、物理、化学小班授课，由教学经验丰富的名师授课，分为同步、提高、培优等班型。分层次、限人数，确保每一位学生都有收获。</div>
      
                      <img style="width:38px;" src="../assets/click-img.png" alt="">
                    </div>
                </div>
            </div>
        </div> -->

    </div>

    <!-- 产品创新 -->
    <div style="padding: 20px 0 50px;background-color: #F7F7F7;">
      <div
        id="产品创新"
        class="anchorPoint"
      ></div>

      <contentTitle
        text='产品创新'
        style="margin-bottom: 30px;"
      />
      <div class="explain-box">
        <div style="padding: 0px 80px 0 40px;">
          <div class="explain-box-tit">
            湖南中考通小程序
            <div
              class=""
              style="position:absolute;width: 32px;height:2px;background-color: #0050A7;bottom: -25%;"
            ></div>
          </div>

          <div class="si_content">湖南中考通是帮助长沙市中考家庭解决各类升学问题的综合性资讯平台。由知名教育咨询机构，中考教研团队和信息技术部门联合打造。汇集长沙中考各类信息资讯，采用人工智能技术，为考生提供中考备考、政策分析、志愿填报、升学指导等一站式升学辅助服务。</div>

        </div>

        <img
          style="width: 200px;height: 200px;margin-right: 50px;"
          src="../assets/course-page/zkt-icon.jpg"
          alt=""
          class="scaleImg_hover"
        >
      </div>

      <div class="explain-box">
        <div style="padding: 0px 80px 0 40px;">
          <div class="explain-box-tit">
            弘知初中语文小程序
            <div
              class=""
              style="position:absolute;width: 32px;height:2px;background-color: #0050A7;bottom: -25%;"
            ></div>
          </div>

          <div class="si_content">语文提分帮，弘知教育推出的初中语文在线学习平台，收纳初中语文六册教材内课文，将语文试卷拆分为专项小块，分专项边学边练，错题自动归入错题本，方便学生考前补足短板。语文提分帮采用测-学-练-测-辅五环学习模式，设有答题积分榜，激励学生通过学习冲击榜首，形成良好、浓厚的学习、竞争氛围。</div>

        </div>

        <img
          style="width: 200px;height: 200px;margin-right: 50px;"
          src="../assets/course-page/chinese-big.jpg"
          alt=""
          class="scaleImg_hover"
        >
      </div>

      <div class="explain-box">
        <div style="padding: 0px 80px 0 40px;">
          <div class="explain-box-tit">
            弘知初高中物理小程序
            <div
              class=""
              style="position:absolute;width: 32px;height:2px;background-color: #0050A7;bottom: -25%;"
            ></div>
          </div>

          <div class="si_content">由弘知教育推出的初高中物理在线学习平台。内含有500多节物理课程视频、历年考试真题、全套物理知识点。内容版块划分精细，核心知识点突出，学生每天仅需上线10分钟，就能有效解决物理学习痛点、疑点、难点，帮助学生逐一突破物理难题，有效解决学生使用大部头纸质书籍时搬运难、查找难、保存难的问题。</div>

        </div>

        <img
          style="width: 200px;height: 200px;margin-right: 50px;"
          src="../assets/course-page/physics-big.jpg"
          alt=""
          class="scaleImg_hover"
        >
      </div>

      <div class="explain-box">
        <div style="padding: 0px 80px 0 40px;">
          <div class="explain-box-tit">
            弘知初高中化学小程序
            <div
              class=""
              style="position:absolute;width: 32px;height:2px;background-color: #0050A7;bottom: -25%;"
            ></div>
          </div>

          <div class="si_content">化学提分帮，初高中化学学习辅助工具，该产品主要帮助学生掌握化学基础知识直至能灵活运用，产品内含化学元素周期表、常用化学方程式大全、元素化合价、金属活动性顺序表等基础知识并可智能匹配相应习题，可以直接搜索使用，也可以按照定制计划按时按量对内容进行学习，帮助学生从基础知识的积累展开学习。</div>

        </div>

        <img
          style="width: 200px;height: 200px;margin-right: 50px;"
          src="../assets/course-page/chemistry.jpg"
          alt=""
          class="scaleImg_hover"
        >
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import NavBar from "@/components/navBar.vue";
import Footer from "@/components/Footer.vue";
import contentTitle from "@/components/contentTitle.vue";

export default {
  name: "course",
  components: {
    NavBar,
    Footer,
    contentTitle,
  },
  data() {
    return {
      content_control: "1", // 1为课程设置，2为科目介绍，3为产品创新
      tabData: [
        { name: "课程设置", status: true },
        { name: "科目介绍", status: false },
        { name: "产品创新", status: false },
      ],
      navIndexs: "3-1",
      nav_control: true, // 科目导航是否显示
      position_top: 0,
    };
  },
  created() {
    this.fetchData();
  },
  mounted() {
    let that = this;
    // console.log(this.$route.query)
    let obj = this.$route.query;
    let data = that.tabData;
    data.forEach(function (res, index) {
      if (res.name === obj.type) {
        res.status = true;
      } else {
        res.status = false;
      }
    });
    // console.log("22",data)
    that.tabData = data;

    // 监听滚动事件，然后用handleScroll这个方法进行相应的处理
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    document.removeEventListener("scroll", this.handleScroll);
  },
  watch: {
    $route: "fetchData",
  },
  methods: {
    fetchData() {
      console.log("路由发送变化doing...");
      let that = this;
      // console.log(this.$route.query)
      let obj = this.$route.query;
      let data = that.tabData;
      data.forEach(function (res, index) {
        if (res.name === obj.type) {
          res.status = true;
        } else {
          res.status = false;
        }
      });
      // console.log("22",data)
      that.tabData = data;
      if (obj.type === "课程设置") {
        that.content_control = "1";
        that.navIndexs = "3-1";
      } else if (obj.type === "科目介绍") {
        that.content_control = "2";
        that.navIndexs = "3-2";
      } else if (obj.type === "产品创新") {
        that.content_control = "3";
        that.navIndexs = "3-3";
      }
    },
    selectContent(e, index) {
      this.scrollIntoView(e);

      let that = this;
      // console.log(e)
      if (e === "课程设置") {
        that.content_control = "1";
        that.navIndexs = "3-1";
      } else if (e === "科目介绍") {
        that.content_control = "2";
        that.navIndexs = "3-2";
      } else if (e === "产品创新") {
        that.content_control = "3";
        that.navIndexs = "3-3";
      }

      let data = that.tabData;
      data.forEach(function (res, index) {
        res.status = false;
      });
      data[index].status = true;
      // console.log(data)
      that.tabData = data;
    },
    jump(e) {
      document.getElementById(e).scrollIntoView();
    },
    // 滚动监听
    handleScroll() {
      let that = this;

      if (that.content_control === "2") {
        //     //获取滚动时的高度
        //     let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        //     // console.log(scrollTop)
        //     let oneHeight = that.$refs
        //     let h = oneHeight.scrollOne.offsetTop // 获取历史节点距离顶部的距离
        //     // console.log("oneHeight",oneHeight.scrollOne.offsetTop)
        //     // let twoHeight = this.$refs.scrollTwo.offsetHeight + oneHeight;
        //     // let threeHeight = this.$refs.scrollThree.offsetHeight + twoHeight;
        // //
        // // console.log(scrollTop)
        //     if (scrollTop > 300) {
        //         that.position_top = scrollTop - 300 + "px"
        //         console.log(that.position_top)
        //     }
        //     if (scrollTop > 200) {
        //     //大于200的时候要做的操作
        //     }
        //     if (scrollTop > h) {
        //     //这是滑动到scrollTwo的距离要做的操作
        //         // that.nav_control = false
        //     }
        //     else {
        //         // that.nav_control = true
        //     }
        //     // if (scrollTop > twoHeight) {
        //     // //这是滑动到scrollThree要做的操作
        //     // }
      }
    },
  },
};
</script>

<style scoped>
.content-title-box {
  position: relative;
  font-size: 38px;
  font-weight: bold;
  text-align: center;
}
.content-title-border {
  position: absolute;
  width: 32px;
  height: 4px;
  background-color: #0050a7;
  left: 50%;
  transform: translateX(-50%);
  bottom: -15%;
}

.select-tab {
  width: 200px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  cursor: pointer;
  margin: 0 40px;
}
.select-tab-true {
  color: #0053ad;
  font-weight: bold;
}
.select-tab-false {
  color: #333333;
  font-weight: bold;
}
.select-tab:hover {
  color: #0053ad;
}


.content-big-box {
  padding: 30px 0;
  /* background-color: #f7f7f7; */
  box-sizing: border-box;
  display: grid;
  width: 100%;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 32px;
}
.content-box {
  display: flex;
  /* width: 570px; */
  background-color: #fff;

  margin: 10px;
}
.content-box:hover {
  box-shadow: 0 0 8px 5px #eaeaea;
}
.content-img {
  flex-shrink: 0;
  width: 210px !important;
  height: 210px !important;
  background-color: #ccc;
  border-radius: 6px;
}
.content-text-box {
  padding: 20px 15px;
}
.content-title {
  font-size: 20px;
  font-family: PingFang-Bold;
}
.content-text {
  margin-top: 10px;
  line-height: 28px;
  font-size: 14px;
  font-weight: 500;
}

/* 科目介绍 */
.subject-big-box {
  text-align: center;
  background-color: #f7f7f7;
  padding: 50px;
}
.subject-cell-box {
  display: flex;
  justify-content: center;
}
.position-relative {
  position: relative;
}
.top-cell-img {
  width: 600px;
  height: 320px;
}
.top-right-img {
  width: 600px;
  height: 320px;
}
.subject-title {
  position: absolute;
  bottom: 30px;
  left: 30px;
  font-size: 32px;
  color: #fff;
}
.bottom-margin-img {
  width: 400px;
  height: 320px;
  margin-right: 20px;
}
.bottom-img {
  width: 400px;
  height: 320px;
}
.position-relative:hover .course-cell-hover {
  display: block;
}
.course-cell-hover {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.course-hover-content {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  height: 100%;
  padding: 50px 30px;
  box-sizing: border-box;
  backdrop-filter: blur(2px) brightness(30%);
  background-color: rgba(0, 0, 0, 0.1);
}
.course-hover-text {
  font-size: 16px;
  line-height: 32px;
  letter-spacing: 1px;
  color: #fff;
}

/* 产品创新 */
.explain-box {
  width: 1200px;
  background-color: #fff;
  margin: 20px auto 0;
  padding: 30px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.explain-box:hover {
  box-shadow: 0 0 8px 5px #eaeaea;
}

.tags {
  line-height: 32px;
  cursor: pointer;
  width: 40px;
  display: block;
}

.go-jump {
  width: 60px;
  position: absolute;
  z-index: 10;
  left: -100px;
  top: 0px;
}

.explain-box-tit {
  position: relative;
  font-size: 25px;
  font-family: "PingFang-Bold";
}

.si_content {
  margin-top: 30px;
  letter-spacing: 1px;
  font-weight: 500;
}

.subtitle {
  position: relative;
  font-size: 26px;
  font-family: "PingFang-Bold";
}
</style>
        